import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '@/pages/HomePage.vue'
import MarketPage from '@/pages/MarketPage.vue'
import ProfilePage from '@/pages/ProfilePage.vue'
import CartPage from '@/pages/CartPage.vue'
import RegisterPage from '@/pages/auth/RegisterPage.vue'
import ForgotPasswordPage from '@/pages/auth/ForgotPasswordPage.vue'
import ResetPasswordPage from '@/pages/auth/ResetPasswordPage.vue'
import VerifyEmailPage from '@/pages/auth/VerifyEmailPage.vue'
import AuthCallbackPage from '@/pages/auth/AuthCallbackPage.vue'
import LegalPage from '@/pages/LegalPage.vue'
import RouteStub from '@/components/RouteStub.vue'
import DesignSystemPreview from '@/pages/__preview/DesignSystemPreview.vue'
import adminRoutes from '@/admin/routes/index.js'
import { clearAdminSession, isAdminTokenExpired } from '@/admin/utils/adminSession.js'
import { getLegalPath } from '@/router/legalLinks.js'

const routes = [
  {path:'/contacts',redirect:'/legal/contacts'},
  {path:'/faq',redirect:'/legal/faq'},
  ...adminRoutes,
  { path: '/',                       name: 'home',           component: HomePage },
  { path: '/market',                 name: 'market',         component: MarketPage },
  { path: '/profile',                name: 'profile',        component: ProfilePage },
  { path: '/cart',                   name: 'cart',           component: CartPage },
  { path: '/register',               name: 'register',       component: RegisterPage },
  { path: '/forgot-password',        name: 'forgot',         component: ForgotPasswordPage },
  { path: '/reset-password',         name: 'reset',          component: ResetPasswordPage },
  { path: '/verify-email',           name: 'verify',         component: VerifyEmailPage },
  { path: '/auth/callback',          name: 'auth-callback',  component: AuthCallbackPage },
  { path: '/legal/:slug',            name: 'legal',          component: LegalPage },
  { path: '/terms', alias: ['/terms-of-use', '/terms-and-conditions'], beforeEnter: async () => getLegalPath('terms'), component: LegalPage },
  { path: '/privacy', alias: ['/privacy-policy', '/privacy-notice'], beforeEnter: async () => getLegalPath('privacy'), component: LegalPage },
  { path: '/cookies', alias: ['/cookie-policy', '/cookie-notice'], beforeEnter: async () => getLegalPath('cookies'), component: LegalPage },
  { path: '/__preview',              name: 'design-preview', component: DesignSystemPreview },
  { path: '/:pathMatch(.*)*',        name: 'notfound',       component: RouteStub }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, saved) {
    if (saved) return saved
    if (to.hash) return { el: to.hash, behavior: 'smooth' }
    return { top: 0, behavior: 'instant' }
  }
})

// Admin route guard — redirect to the admin login when no token is present.
// (The backend also enforces auth on every /api/admin route; this gates the UI.)
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAdmin) {
    const adminToken = localStorage.getItem('admin_token')
    if (!adminToken || isAdminTokenExpired(adminToken)) {
      clearAdminSession()
      return next({
        name: 'AdminLogin',
        query: {
          ...(adminToken ? { reason: 'session-expired' } : {}),
          redirect: to.fullPath,
        },
      })
    }
  }
  next()
})

export default router
